import { render, staticRenderFns } from "./pointChangeList.vue?vue&type=template&id=cc6aecdc&scoped=true"
import script from "./pointChangeList.vue?vue&type=script&lang=js"
export * from "./pointChangeList.vue?vue&type=script&lang=js"
import style0 from "./pointChangeList.vue?vue&type=style&index=0&id=cc6aecdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc6aecdc",
  null
  
)

export default component.exports